//@flow
import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { isEmpty } from 'lodash';
import AwardsOverlay from 'components/molecules/awardOverlay';
import { CallToAction } from 'components/atoms/callToAction';
import { OverlayImageCarousel } from 'components/organisms/overlayImageCarousel';
import { ArchitectProjectOverlayDescription } from 'components/molecules/architectOverlayDescription';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {};

export const ArchitectProjectOverlay = (props: Props) => {
  const { data, awardData } = props;
  const overlayData = data[0];
  const { bannerImages, projectPlanImages, galleryImages } = overlayData;
  const [activeBannerSlide, setActiveBannerSlide] = useState(0);
  const [bannerSlider, setBannerSlider] = useState();
  const [activeGallerySlide, setActiveGallerySlide] = useState(0);
  const [gallerySlider, setGallerySlider] = useState();

  const next = () => {
    bannerSlider.slickNext();
  };

  const previous = () => {
    bannerSlider.slickPrev();
  };

  const handleSliderRef = ref => {
    setBannerSlider(ref);
  };

  const nextGallery = () => {
    gallerySlider.slickNext();
  };

  const previousGallery = () => {
    gallerySlider.slickPrev();
  };

  const handleSliderRefGallery = ref => {
    setGallerySlider(ref);
  };

  const renderHeaderButton = () => (
    <CallToAction
      text={'PROJECT DETAILS'}
      onClick={() => {}}
      mode={'dark'}
      className={'architect-overlay-header-button'}
    />
  );

  const renderBannerContent = () => (
    <OverlayImageCarousel
      className={'banner-container-overlay'}
      type={'architect-overlay-banner'}
      cssFor={'architect-overlay-banner'}
      Images={bannerImages}
      activeSlide={activeBannerSlide}
      setActiveSlide={setActiveBannerSlide}
      next={next}
      previous={previous}
      handleSliderRef={handleSliderRef}
      key={'17'}
    />
  );

  const renderMiddleProjectInfo = () => (
    <div className={'project-middle-info'}>
      <div className={'left-section'}>
        <h2>{overlayData.title}</h2>
        <ArchitectProjectOverlayDescription
          descriptionOne={overlayData.descriptionOne}
          descriptionTwo={overlayData.descriptionTwo}
          projectRichTextOne={overlayData.projectRichTextOne}
          projectRichTextTwo={overlayData.projectRichTextTwo}
        />
      </div>
      {projectPlanImages && projectPlanImages.length > 0 && (
        <div className={'right-section'}>{renderProjectImageCarousal()}</div>
      )}
    </div>
  );

  const renderAwardSection = () => (
    <div className={'overlay-award-section'}>
      <span className="award-heading">AWARDS & RECOGNITION</span>
      <AwardsOverlay data={awardData} />
    </div>
  );

  const renderProjectGallery = () => (
    <OverlayImageCarousel
      className={'gallery-container-overlay'}
      type={'architect-overlay-banner'}
      cssFor={'architect-overlay-gallery'}
      Images={galleryImages}
      activeSlide={activeGallerySlide}
      setActiveSlide={setActiveGallerySlide}
      next={nextGallery}
      previous={previousGallery}
      handleSliderRef={handleSliderRefGallery}
      key={'18'}
    />
  );

  const renderProjectImageCarousal = () => (
    <Carousel
      className={'image-carousal-control'}
      pauseOnHover={false}
      controls={true}
      pause={false}
      interval={null}
      fade={false}
      nextIcon={
        projectPlanImages.length > 1 && (
          <span className={'carousel-control-next-icon'} />
        )
      }
      prevIcon={
        projectPlanImages.length > 1 && (
          <span className={'carousel-control-prev-icon'} />
        )
      }
    >
      {projectPlanImages.map((slides, idx) => {
        return (
          <Carousel.Item key={idx}>
            <img
              className={'carousel-image'}
              src={slides.image}
              alt={'broken'}
            />
          </Carousel.Item>
        );
      })}
    </Carousel>
  );

  return (
    <div className={'architect-overlay-desktop'}>
      {/*{renderHeaderButton()}*/}
      {!isEmpty(bannerImages) && renderBannerContent()}
      {renderMiddleProjectInfo()}
      {!isEmpty(awardData) && renderAwardSection()}
      {!isEmpty(galleryImages) && renderProjectGallery()}
    </div>
  );
};
